/*
 * IRIS Interactive
 *
 * NOTICE OF LICENSE
 *
 * This source file is no subject to a specific license
 * but it belongs to the company IRIS Interactive.
 * You can contact IRIS Interactive at the following
 * address: contact@iris-interactive.fr
 *
 * @author      Lucas ROCHE
 * @date        16/02/2021 08:38
 * @copyright   Copyright (c) 2002-2021 IRIS Interactive, Inc. (http://www.iris-interactive.fr)
 */

export default class Menu {
    static trigger_menu_open            = '[data-trigger="wpiris-menu-open"]';
    static trigger_menu_close           = '[data-trigger="wpiris-menu-close"]';
    static trigger_close_submenu        = '[data-trigger="wpiris-submenu-close"]';
    static class_topbar                 = '.topbar';
    static class_menu                   = '.mainnav';
    static class_menu_item_has_children = '.mainnavItem--has-children';
    
    constructor()
    {
        Menu.toogle_class_menu();
        Menu.toggle_class_menu_item_has_children();
        Menu.close_menu();
        Menu.close_submenu();
    }
    
    static toogle_class_menu()
    {
        $( Menu.trigger_menu_open ).on( 'click', function () {
            $( Menu.class_topbar ).toggleClass( 'open' );
            $( Menu.class_menu ).toggleClass( 'open' );
        } );
    }
    
    static toggle_class_menu_item_has_children()
    {
        $( Menu.class_menu_item_has_children + ' > a' ).on( 'click', function ( e ) {
            e.preventDefault();
            
            const current = $( this ).parent( '.mainnavItem' );
            
            if ( current.hasClass( 'open' ) ) {
                $( Menu.class_menu_item_has_children ).removeClass( 'open' );
            } else {
                $( Menu.class_menu_item_has_children ).removeClass( 'open' );
                current.addClass( 'open' );
            }
            
        } );
    }
    
    static close_menu()
    {
        $( document ).on( 'click', Menu.trigger_menu_close, function() {
            $( Menu.class_menu_item_has_children ).removeClass( 'open' );
            $( Menu.class_menu ).removeClass( 'open' );
        } );
    }
    
    static close_submenu()
    {
        $( document ).on( 'click', Menu.trigger_close_submenu, function () {
            $( this ).parents( '.mainnavItem' ).removeClass( 'open' );
        } );
    }
}